import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { images } from "assets/AssetHelper";
import { detailsData } from "./details";

const TagTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  can_create,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang] = useState("en");
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          detailsTemplateData={{
            pageTitle: t("lookups_tags.list_title"),
            data: {
              images: [{ id: 0, img: images.Logo }],
              list: detailsData({ data: details }),
            },
          }}
          table={{
            isDetails: false,
            list: data, // data
            listTitle: t("lookups_tags.list_title"),
            createBtnTitle: can_create && t("lookups_tags.add"),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "localized_data.en.name",
                Header: t("lookups_tags.english_tag"),
                sort: true,
                sortKey: "name",
                sortLang: "en",
              },
              {
                accessor: "localized_data.ar.name",
                Header: t("lookups_tags.arabic_tag"),
                sort: true,
              },
              {
                accessor: "created_at",
                Header: t("gift_cards.created_at"),
                sort: true,
              },
              {
                accessor: "updated_at",
                Header: t("gift_cards.updated_at"),
                sort: true,
              },
              { accessor: "Actions", Header: t("cart_logs.actions") },
            ],
            isSearch: true,
            searchInputPlaceholder: t("gift_cards.search_by_tag"),
            isChecked: false,
            total_count: count,
            setFilterObj,
            className:
              "organization-table system-configurations-table main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList, //if you want to add custom actions list ...
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            // lw mafesh id add mafesh values -------- lw fe id yb2a edit values
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: () =>
              structure(supportedLang, [{ id: "1", name: "test" }], t),
            validationSchema: validationSchema,
            deleteFun: deleteFun,
            title: id ? t("lookups_tags.edit") : t("lookups_tags.add"),
            submitTitle: id
              ? t("admin_users.btn_update")
              : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          // DetailsComponent={<Details />} //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default TagTemplate;
